module.exports = __webpack_public_path__ + "static/img/a11.38d734bb.png";